<img src={{image.small}}  style="cursor: pointer;" class="img-fluid" (click)="open()">

  